import React from 'react';

// Tüm bayraklar için standart bir stil tanımlayalım (React inline style)
// Bu, <img> ve emoji (span) bayraklarının aynı boyutta görünmesini sağlar.
const flagStyle = {
  width: '1.5em',    // Resimlerin genişliği (yazı tipi boyutuna göre)
  height: '1.2em',   // Resimlerin yüksekliği
  objectFit: 'cover', // Resmin orantılı sığması için
  verticalAlign: 'middle', // Dikey hizalama
  borderRadius: '2px'      // Hafif yuvarlak köşe
};

export const FLAGS = {
  // Emojileri <span> içine alarak stil veriyoruz
  TR: <span style={{ ...flagStyle, fontSize: '1.5em' }}>🇹🇷</span>,
  EN: <span style={{ ...flagStyle, fontSize: '1.5em' }}>🇬🇧</span>, // (İngiltere bayrağı varsayımı)
  FR: <span style={{ ...flagStyle, fontSize: '1.5em' }}>🇫🇷</span>,

  // ⭐️ Kürtçe için <img> etiketi kullanıyoruz

  TR: (
    <img
      src="/img/tr.svg.png" // 1. Adım'da kaydettiğiniz dosya yolu (public klasöründen başlar)
      alt="Turkish Flag"
      style={flagStyle}
    />
  ),
  EN: (
    <img
      src="/img/eng.svg.png" // 1. Adım'da kaydettiğiniz dosya yolu (public klasöründen başlar)
      alt="English Flag"
      style={flagStyle}
    />
  ),
  FR: (
    <img
      src="/img/fr.svg.png" // 1. Adım'da kaydettiğiniz dosya yolu (public klasöründen başlar)
      alt="France Flag"
      style={flagStyle}
    />
  )
};